import { forwardRef } from 'react';

import { fontStyles } from '../../../../styles/typography';
import { TextSkeleton } from '../../../Skeleton';
import { getScoreIcon } from '../../../TokenProfile/TokenLiquidityScore/getScoreIcon';

export const LiquidityScoreInline = forwardRef<
  HTMLDivElement,
  { score: number | undefined; isLoading: boolean }
>(function LiquidityScoreInline({ score, isLoading }, ref) {
  const isValidScore = score !== undefined && score >= 0;
  const icon = isLoading ? getScoreIcon(undefined) : getScoreIcon(isValidScore ? score : undefined);
  const label = isLoading ? <TextSkeleton width={14} height={16} /> : isValidScore ? score : '-';

  return (
    <div
      ref={ref}
      className={fontStyles({
        variant: 'LABEL_SM',
        class: ['items-center', 'flex', 'gap-1.5'],
      })}
    >
      {icon}
      {label}
    </div>
  );
});
